import { useSelector } from 'react-redux';
import { selectCurrentStep, selectTotalSteps } from '../../store/slices/registrationSlice';
import { User, Buildings, Target, SlidersHorizontal, ShieldCheck, Check } from '@phosphor-icons/react';
import AboutYouStep from './steps/AboutYouStep';
import ClinicInfoStep from './steps/ClinicInfoStep';
import SpecializationsStep from './steps/SpecializationsStep';
import PreferencesStep from './steps/PreferencesStep';
import VerificationStep from './steps/VerificationStep';
import './RegistrationWizard.css';

const steps = [
  { id: 1, label: 'אודותיך', icon: User },
  { id: 2, label: 'הקליניקה', icon: Buildings },
  { id: 3, label: 'התמחויות', icon: Target },
  { id: 4, label: 'העדפות', icon: SlidersHorizontal },
  { id: 5, label: 'אימות', icon: ShieldCheck }
];

function RegistrationWizard() {
  const currentStep = useSelector(selectCurrentStep);
  const totalSteps = useSelector(selectTotalSteps);

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <AboutYouStep />;
      case 2:
        return <ClinicInfoStep />;
      case 3:
        return <SpecializationsStep />;
      case 4:
        return <PreferencesStep />;
      case 5:
        return <VerificationStep />;
      default:
        return <AboutYouStep />;
    }
  };

  const progressPercent = ((currentStep - 1) / (totalSteps - 1)) * 100;

  return (
    <div className="registration-wizard">
      {/* Header */}
      <div className="reg-wizard-header">
        <h1>הרשמה למערכת</h1>
        <p>
          מלאו את הפרטים הבאים כדי להתחיל
          <span className="wizard-step-counter"> · שלב {currentStep} מתוך {totalSteps}</span>
        </p>
      </div>

      {/* Progress: numbered dots connected by an animated track */}
      <div className="reg-wizard-progress">
        <div className="reg-wizard-progress-track" aria-hidden="true">
          <div
            className="reg-wizard-progress-fill"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
        {steps.map((step) => {
          const isActive = step.id === currentStep;
          const isCompleted = step.id < currentStep;
          const Icon = step.icon;

          return (
            <div
              key={step.id}
              className={`wizard-step-dot ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
            >
              <div className="wizard-dot-circle">
                {isCompleted ? (
                  <Check size={16} weight="bold" />
                ) : (
                  <Icon size={16} weight={isActive ? 'fill' : 'regular'} />
                )}
              </div>
              <span className="wizard-dot-label">{step.label}</span>
            </div>
          );
        })}
      </div>

      {/* Content Area — keyed remount triggers the slide-in transition */}
      <div className="reg-wizard-content">
        <div className="wizard-step-pane" key={currentStep}>
          {renderStep()}
        </div>
      </div>
    </div>
  );
}

export default RegistrationWizard;
